module.exports = __webpack_public_path__ + "img/logo2.79cfc50c.png";